import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, actionLabel, onAction }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      py: 8,
      px: 2,
      color: 'text.secondary',
    }}
  >
    <Box sx={{ fontSize: 56, mb: 1.5, color: 'primary.light', '& svg': { fontSize: 'inherit' } }}>{icon}</Box>
    <Typography variant="h6" color="text.primary" gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ maxWidth: 420, mb: 2 }}>
        {description}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="contained" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
